/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityReportResource } from './';
import {
    ActivityReportResourceFromJSON,
    ActivityReportResourceFromJSONTyped,
    ActivityReportResourceToJSON,
} from './';
import type { InvoiceDetailsResource } from './';
import {
    InvoiceDetailsResourceFromJSON,
    InvoiceDetailsResourceFromJSONTyped,
    InvoiceDetailsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface LotResource
 */
export interface LotResource {
    /**
     * 
     * @type {string}
     * @memberof LotResource
     */
    id?: string;
    /**
     * 
     * @type {ActivityReportResource}
     * @memberof LotResource
     */
    activityReport?: ActivityReportResource;
    /**
     * 
     * @type {InvoiceDetailsResource}
     * @memberof LotResource
     */
    invoiceDetails: InvoiceDetailsResource;
    /**
     * is the purchase order mandatory
     * @type {boolean}
     * @memberof LotResource
     */
    purchaseOrderMandatory: boolean;
    /**
     * the purchase order number
     * @type {string}
     * @memberof LotResource
     */
    purchaseOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LotResource
     */
    extraDocumentId?: string;
    /**
     * 
     * @type {string}
     * @memberof LotResource
     */
    extraDocumentName?: string;
    /**
     * 
     * @type {Date}
     * @memberof LotResource
     */
    periodStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof LotResource
     */
    periodEndDate?: Date;
}

/**
 * Check if a given object implements the LotResource interface.
 */
export function instanceOfLotResource(value: object): value is LotResource {
    if (!('invoiceDetails' in value) || value['invoiceDetails'] === undefined) return false;
    if (!('purchaseOrderMandatory' in value) || value['purchaseOrderMandatory'] === undefined) return false;
    return true;
}

export function LotResourceFromJSON(json: any): LotResource {
    return LotResourceFromJSONTyped(json, false);
}

export function LotResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LotResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'activityReport': json['activityReport'] == null ? undefined : ActivityReportResourceFromJSON(json['activityReport']),
        'invoiceDetails': InvoiceDetailsResourceFromJSON(json['invoiceDetails']),
        'purchaseOrderMandatory': json['purchaseOrderMandatory'],
        'purchaseOrderNumber': json['purchaseOrderNumber'] == null ? undefined : json['purchaseOrderNumber'],
        'extraDocumentId': json['extraDocumentId'] == null ? undefined : json['extraDocumentId'],
        'extraDocumentName': json['extraDocumentName'] == null ? undefined : json['extraDocumentName'],
        'periodStartDate': json['periodStartDate'] == null ? undefined : (new Date(json['periodStartDate'])),
        'periodEndDate': json['periodEndDate'] == null ? undefined : (new Date(json['periodEndDate'])),
    };
}

export function LotResourceToJSON(value?: LotResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'activityReport': ActivityReportResourceToJSON(value['activityReport']),
        'invoiceDetails': InvoiceDetailsResourceToJSON(value['invoiceDetails']),
        'purchaseOrderMandatory': value['purchaseOrderMandatory'],
        'purchaseOrderNumber': value['purchaseOrderNumber'],
        'extraDocumentId': value['extraDocumentId'],
        'extraDocumentName': value['extraDocumentName'],
        'periodStartDate': value['periodStartDate'] == null ? undefined : ((value['periodStartDate']).toISOString().substring(0,10)),
        'periodEndDate': value['periodEndDate'] == null ? undefined : ((value['periodEndDate']).toISOString().substring(0,10)),
    };
}

